module.exports = __webpack_public_path__ + "img/CeltCapTechMorrigansVengeance.4114540e.webp";